import axios from 'axios';

const API_BASE_URL = '/api/v1/admin';

const authHeaders = () => ({
  Authorization: localStorage.getItem('token')
});

export const adminFilesApi = {
  bulkUpdateBarcodesByProductCode: (items) => {
    return axios.post(`${API_BASE_URL}/products/barcodes`, { items }, { headers: authHeaders() });
  }
};

